import cx from 'classnames';
import * as React from 'react';

import './styles/Views.scss';

type Props = {
  children?: React.ReactNode;
  className?: string;
  divided?: boolean;
};

function Views(props: Props) {
  const { children, className, divided } = props;

  return (
    <div
      className={cx(
        'Views',
        {
          'Views--divided': divided,
        },
        className
      )}>
      {children}
    </div>
  );
}

export default Views;
